<template>
    <div class="col-12">
        <div class="d-flex flex-column" style="gap: 8px; margin-top: 16px;">
            <label>Customer List</label>
            <el-table
                :data="customerList"
                style="width: 100%;"
                class="customer-list-view-table">
                <template slot="empty">
                    <span style="color: #909399;">No data</span>
                </template>
                <el-table-column label="Uploaded Date">
                    <template slot-scope="scope">{{ scope.row.date }}</template>
                </el-table-column>
                <el-table-column property="name" label="Customer List Name">
                </el-table-column>
                <el-table-column property="total" align="center" label="Total Customers">
                </el-table-column>
                <el-table-column label="Action" align="right" width="100">
                    <template slot-scope="scope">
                        <i class="el-icon-download customer-list-action-icon" 
                           :title="'Download ' + scope.row.name"
                           style="color: #000000; font-size: 16px; cursor: pointer;"
                           @click="onDownloadClicked(scope.row)"></i>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { Table, TableColumn } from 'element-ui';
import { downloadFileInBackgroundCleanID } from '../../helpers/downloadFile';

export default {
    name: 'UserClientEdit',
    components: {
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    props: {
        customerList: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        onDownloadClicked(row) {
            const appDataServerUrl = process.env.VUE_APP_DATASERVER_URL;
            const customer_id = row && row.id ? row.id : "";
            const customer_name = row && row.name ? row.name.replace(/ /g, '_') : "";
            const file_name = `${customer_name}.csv`;
            const url = `${appDataServerUrl}/configuration/predict-id/download-customer/${customer_id}`;
            downloadFileInBackgroundCleanID(url, file_name);
        },
    }
}
</script>

<style scoped>
.customer-list-view-table {
    width: 100%;
}

.customer-list-action-icon {
    color: #000000;
    font-size: 16px;
    cursor: pointer;
}

.customer-list-action-icon:hover {
    opacity: 0.7;
    transition: opacity 0.2s;
}
</style>
